import { Injectable } from "@angular/core";
import { CachedStore } from "@fry-it/risr-core";
import { Blueprint, BlueprintApiResponse } from "./blueprint";

@Injectable({
    providedIn: 'root'
})
export class BlueprintStore extends CachedStore<BlueprintApiResponse, Blueprint> {
    prefix = 'blueprints';

    public async getAll(): Promise<Blueprint[]> {
        const blueprints = await this.fetchAll();
        return blueprints.map(this.fromApiResponse);
    }

    protected fetchOne(key: string): Promise<BlueprintApiResponse> {
        return this.api.get<BlueprintApiResponse>(`/blueprints/${key}`);
    }

    protected fetchAll(): Promise<BlueprintApiResponse[]> {
        return this.api.get<BlueprintApiResponse[]>(`/blueprints/`);
    }

    protected fromApiResponse(response: BlueprintApiResponse): Blueprint {
        return Blueprint.fromApiResponse(response);
    }
}